/** Toggle site sections and routes without removing underlying code. */
export const ARTICLES_VISIBLE = false;
